import { IRequestContext } from '@msdyn365-commerce/core-internal';
import { useMemo } from 'react';
import { CookieService } from '../cookie-service';

export const useCookieService = (request: IRequestContext) => {
    const cookieService = useMemo(() => new CookieService(request), [request]);
    return cookieService;
};
